import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Badge,
  Button,
  UncontrolledTooltip,
  Input,
} from "reactstrap";
import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { useNavigate } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import { showAlert } from "components/CommonComponents/CommonFunctions";

const CENTER_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "ACTIVE" },
  { value: "INACTIVE", label: "INACTIVE" },
  // { value: "PENDING", label: "Pending" },
];

// STATIC TRAINING CENTERS LIST
const trainingCentersList = [
  {
    id: 1,
    centerCode: "TC-001",
    centerName: "Pune Industrial Training Center",
    address: "Plot No. 24, MIDC Industrial Area, Hinjewadi Phase 1",
    city: "Pune",
    state: "Maharashtra",
    contactPerson: "Rahul Patil",
    contactMobile: "9876543210",
    capacity: 150,
    status: "ACTIVE",
    createdAt: "2024-01-10",
  },
  {
    id: 2,
    centerCode: "TC-002",
    centerName: "Bangalore Skill Hub",
    address: "2nd Floor, Tech Park Building, Whitefield Main Road",
    city: "Bangalore",
    state: "Karnataka",
    contactPerson: "Anita Sharma",
    contactMobile: "9123456789",
    capacity: 300,
    status: "ACTIVE",
    createdAt: "2024-01-15",
  },
  {
    id: 3,
    centerCode: "TC-003",
    centerName: "Delhi Technical Academy",
    address: "Block B, Okhla Industrial Estate, Phase II",
    city: "New Delhi",
    state: "Delhi",
    contactPerson: "Vikram Singh",
    contactMobile: "9988776655",
    capacity: 225,
    status: "INACTIVE",
    createdAt: "2024-01-18",
  },
  {
    id: 4,
    centerCode: "TC-004",
    centerName: "Chennai Manufacturing Institute",
    address: "No. 56, SIDCO Industrial Estate, Ambattur",
    city: "Chennai",
    state: "Tamil Nadu",
    contactPerson: "Suresh Kumar",
    contactMobile: "9090909090",
    capacity: 500,
    status: "ACTIVE",
    createdAt: "2024-01-22",
  },
  {
    id: 5,
    centerCode: "TC-005",
    centerName: "Ahmedabad Industrial School",
    address: "Survey No. 78, GIDC Industrial Area, Vatva",
    city: "Ahmedabad",
    state: "Gujarat",
    contactPerson: "Mehul Shah",
    contactMobile: "9812345678",
    capacity: 100,
    status: "ACTIVE",
    createdAt: "2024-01-25",
  },
];

function TrainingCenter() {
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);

  const [searchState, setSearchState] = useState({
    query: "",
    status: null,
    filterParams: [],
  });

  // columns
  const columns = [
    { Header: "Sr. No.", accessor: "id" },
    // { Header: "Center Code", accessor: "centerCode" },
    { Header: "Center Name", accessor: "centerName" },
    // { Header: "Address", accessor: "address" },
    // { Header: "City", accessor: "city" },
    // { Header: "State", accessor: "state" },

    {
      Header: "Full Address",
      accessor: "fullAddress",
      Cell: ({ row }) => {
        const { address, city, state } = row.original;
        return (
          <span>
            {address}, {city}, {state}
          </span>
        );
      },
    },
    // { Header: "Contact Person", accessor: "contactPerson" },
    // { Header: "Mobile", accessor: "contactMobile" },
    // { Header: "Capacity", accessor: "capacity" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge
          color={
            value === "ACTIVE"
              ? "success"
              : value === "INACTIVE"
                ? "warning"
                : "warning"
          }
          pill
        >
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { id } = row.original;
        const isActive = row.original.status === "ACTIVE";
        return (
          <div className="d-flex  align-items-center">
            <Button
              color="link"
              className="p-0"
              onClick={(e) => {
                e.stopPropagation();
                openEditModal(row.original);
              }}
              id={`edit-${id}`}
            >
              <i className="fas fa-edit mr-1 table-action-info" />
            </Button>
            <UncontrolledTooltip delay={0} target={`edit-${id}`}>
              Edit
            </UncontrolledTooltip>

            <span className="mr-1 text-muted">|</span>

            <Button
              color="link"
              size="lg"
              className="d-flex align-items-center p-0 ml-1"
              id={`status${id}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleStatus(row.original);
              }}
            >
              {isActive ? (
                <>
                  <i className="fa-regular fa-circle-xmark fa-md table-action-delete mr-1" />
                </>
              ) : (
                <>
                  <i className="fa-regular fa-circle-check fa-md table-action-success mr-1" />
                </>
              )}
            </Button>
            <UncontrolledTooltip delay={0} target={`status${id}`}>
              {isActive ? "Inactivate" : "Activate"}
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  const toggleStatus = (data) => {
    const isActive = data.status === "ACTIVE";
    const newStatus = isActive ? "INACTIVE" : "ACTIVE ";
    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this training center?`,
      message: `Training center "${data.centerName}" will be marked as ${newStatus.toLowerCase()}.`,
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {},
    });
  };

  const openEditModal = (data) => {
    navigate(`/admin/training-center/add-center`, {
      state: { mode: "edit", instructorData: data },
    });
  };

  const hanldeOnRowClick = (rowData) => {
    const encodedId = urlEncodedId(rowData.id);
    navigate(`/admin/training-centers/${encodedId}/details`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={
            props.data.value === "ACTIVE"
              ? "success"
              : props.data.value === "INACTIVE"
                ? "danger"
                : "warning"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={
            props.data.value === "ACTIVE"
              ? "success"
              : props.data.value === "INACTIVE"
                ? "danger"
                : "warning"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <CardTitle tag="h3" className="mb-0">
                  Training Centers
                </CardTitle>
                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                    navigate("/admin/training-center/add-center ", {
                      state: { mode: "add" },
                    })
                  }
                >
                  <i className="fa fa-plus mr-1" />
                  Training Center
                </Button>
              </CardHeader>

              <CardBody>
                {/* Filters */}
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    {/* <Input
                      placeholder="Search by center code"
                      className="mr-2 mb-2 filter-select"
                    /> */}
                    <Input
                      placeholder="Search by center name"
                      className="mr-2 mb-2 filter-select"
                    />
                    {/* <Input
                      placeholder="Search by city"
                      className="mr-2 mb-2 filter-select"
                    />
                    <Input
                      placeholder="Search by state"
                      className="mr-2 mb-2 filter-select"
                    /> */}
                    <Input
                      placeholder="Search by address"
                      className="mr-2 mb-2 filter-select"
                    />
                    {/* <Input
                      placeholder="Search by contact person"
                      className="mr-2 mb-2 filter-select"
                    />{" "}
                    <Input
                      placeholder="Search by mobile no"
                      className="mr-2 mb-2 filter-select"
                    />{" "} */}
                    {/* <Input
                      placeholder="Search by capacity"
                      className="mr-2 mb-2 filter-select"
                    /> */}
                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={CENTER_STATUS_OPTIONS}
                      placeholder="Status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      onKeyDown={handleKeyDown}
                    />
                    <Button
                      color="default"
                      className="d-flex align-items-center mb-2 mt-0 filter-btn btn-deep-blue"
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>
                    {searchState.filterParams.length > 0 && (
                      <Button
                        color="default"
                        className="mb-3 filter-btn btn-simple"
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className="mt-2 mb-3 mx-1">
                  {trainingCentersList.length ? (
                    <span className="total-records">
                      Total Records : {trainingCentersList.length}
                    </span>
                  ) : null}
                </div>

                <CommonTable
                  columns={columns}
                  data={trainingCentersList}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalRecords={trainingCentersList.length}
                  showPaginationBottom
                  // rowClick={(row) => hanldeOnRowClick(row)}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TrainingCenter;
